import { Suspense, lazy } from 'react'
import { Loader } from '@nv/basic-components'
import { EventCountdownTimeDateContainer, Skeleton } from '@nv/components'
import BalletBox from '@nv/images/design/ballet-box-icon'
import DividerIcon from '@nv/images/design/divider-icon'
import { useTranslation } from 'react-i18next'
import styles from './AdminEventContent.module.scss'

const EventStatus = lazy(() => import('../event_status/EventStatus'))
const LazyNVButton = lazy(() => import('@nv/basic-components').then((module) => ({ default: module.NVButton })))

export const AdminEventContent = ({
  event,
  title,
  votingOpen,
  onSelectEvent,
  loadingVotingOpen,
  isHeader = false,
  hasVoted = false,
}: any) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language

  return (
    <div className={styles['container']}>
      <div className={styles['body']}>
        <div className={styles['content']}>
          <BalletBox />

          <div className={styles['title']}>
            <h3 className={styles['label']}>{title[currentLanguage]}</h3>

            <div className={styles['positions']}>
              <Suspense fallback={<Loader />}>
                {!loadingVotingOpen ? (
                  <>
                    <EventStatus
                      votingOpen={votingOpen}
                      eventState={event.state}
                      nominationState={event.nominationState}
                      hasVoted={hasVoted}
                    />
                    <DividerIcon style={{ margin: '0 1.25rem' }} />
                    <span className={styles['positions--text']}>
                      {event.questions?.length} {t('events.labels.positions')}
                    </span>
                  </>
                ) : (
                  <>
                    <Skeleton width={300} height={40} />
                    <DividerIcon style={{ margin: '0 1.25rem' }} />
                    <Skeleton width={100} height={40} />
                  </>
                )}
              </Suspense>
            </div>

            {!isHeader && (
              <Suspense fallback={<Loader />}>
                <LazyNVButton text={t('main.details')} height={37} onClick={() => onSelectEvent(event)} />
              </Suspense>
            )}
          </div>
        </div>

        <Suspense fallback={<Loader />}>
          {!loadingVotingOpen ? <EventCountdownTimeDateContainer event={event} votingOpen={votingOpen} /> : <Skeleton width={150} />}
        </Suspense>
      </div>
    </div>
  )
}
